import {
    Region,
    TranslatedRegionName,
} from '@experiences/constants';
import { useCallback } from 'react';
import { useIntl } from 'react-intl';

export const useRegionDisplay = () => {
    const { formatMessage: translate } = useIntl();

    const getRegionDisplayValue = useCallback((region: Region | string | undefined): string => {
        if (!region) {
            return translate({ id: TranslatedRegionName[Region.None] });
        }

        // Check if the region exists in the enum
        if (region in TranslatedRegionName) {
            return translate({ id: TranslatedRegionName[region as keyof typeof TranslatedRegionName] });
        }

        // For undefined regions, return the raw region value
        return region;
    }, [ translate ]);

    return getRegionDisplayValue;
};
